import getCookie from "./getCookie";

function getCookieInt(name: string) {
  const cookie = getCookie(name);
  return cookie != undefined ? parseInt(cookie) : undefined;
}

export default getCookieInt;
